module.exports = __webpack_public_path__ + "static/media/right-arrow-dark.687dbf24.svg";